// extracted by mini-css-extract-plugin
export default {"support":"supportResources_support__CpDmE","supportButton":"supportResources_supportButton__fEwOk","liveChatButton":"supportResources_liveChatButton__2svp9"};